export class Subscription {
	constructor(private readonly onUnsubscribe: () => void) {}

	unsubscribe(): void {
		this.onUnsubscribe();
	}
}
